import React, { CSSProperties, FC } from 'react';
import { styled } from '@material-ui/core/styles';

const StyledStep = styled('h1')(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '18px',
  lineHeight: '22px',
  textAlign: 'center',
  textTransform: 'uppercase',
  color: theme.palette.primary.main,
  margin: 0,
  marginBottom: 9,
  [theme.breakpoints.up('sm')]: {
    marginBottom: 14,
  },
}));

interface Props {
  num: number;
  style?: CSSProperties;
}

const Step: FC<Props> = ({ num, style }) => {
  return <StyledStep style={style}>Step {num}</StyledStep>;
};

export default Step;
